import React, { useEffect, useState } from 'react';
import { Clock, Truck, Package } from 'lucide-react';
import { kpis } from '../data/mockData';
interface TopBarProps {
  onFilterAlerts?: (severity: 'critical' | 'warning' | 'low' | 'all') => void;
}
export function TopBar({
  onFilterAlerts
}: TopBarProps) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setElapsedSeconds(s => s + 1), 1000);
    return () => clearInterval(timer);
  }, []);
  const startMinutes = 13 * 60 + 3;
  const totalMinutes = startMinutes + Math.floor(elapsedSeconds / 60);
  const hours = Math.floor(totalMinutes / 60) % 24;
  const minutes = totalMinutes % 60;
  const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  return <div className="h-16 bg-slate-950 border-b border-slate-800 flex items-center shrink-0 z-10" data-id="element-659">
      {/* Logo — 72px wide to align with icon rail */}
      <div className="w-[72px] shrink-0 flex items-center justify-center" data-id="element-660">
        <div className="w-8 h-8 rounded-lg bg-brand-blue/20 border border-brand-blue/30 flex items-center justify-center" data-id="element-661">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-662">
            <path d="M12 2L4 7V17L12 22L20 17V7L12 2Z" stroke="#3b82f6" strokeWidth="2" strokeLinejoin="round" data-id="element-663" />
            <path d="M12 8V16" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" data-id="element-664" />
            <path d="M8 10L12 8L16 10" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-665" />
          </svg>
        </div>
      </div>

      {/* Shift Info */}
      <div className="flex items-center gap-6 pl-4" data-id="element-666">
        <div className="flex flex-col" data-id="element-667">
          <span className="text-[11px] font-medium text-slate-400" data-id="element-668">
            Monday, April 13
          </span>
          <span className="text-sm font-semibold text-slate-200" data-id="element-669">
            Shift 2 <span className="text-slate-500 font-normal" data-id="element-670">–</span>{' '}
            <span className="text-slate-300 font-medium" data-id="element-671">12:00‑20:00</span>
          </span>
        </div>
      </div>

      {/* Center: Digital Clock */}
      <div className="flex-1" data-id="element-672" />
      <div className="absolute left-1/2 -translate-x-1/2" data-id="element-673">
        <span className="text-[28px] block font-light tracking-widest leading-none border border-slate-850 text-[#5E6877]" style={{
        fontFamily: "'Orbitron', sans-serif",
        padding: '5px',
        backgroundColor: '#070c17',
        borderRadius: '4px'
      }} data-id="element-674">
          {timeString}
        </span>
      </div>

      {/* Right: KPIs */}
      <div className="flex items-center gap-6 pr-6" data-id="element-675">
        <KPICard icon={<Truck className="w-3.5 h-3.5 text-slate-400" data-id="element-677" />} label="Active Drivers" value={`${kpis.activeDrivers.current}/${kpis.activeDrivers.total}`} data-id="element-676" />

        <div className="w-px h-8 bg-slate-800" data-id="element-678" />

        <KPICard icon={<Package className="w-3.5 h-3.5 text-slate-400" data-id="element-680" />} label="Deliveries" value={`${kpis.deliveries.current}/${kpis.deliveries.total}`} data-id="element-679" />

        <div className="w-px h-8 bg-slate-800" data-id="element-681" />

        <KPICard icon={<Clock className="w-3.5 h-3.5 text-slate-400" data-id="element-683" />} label="On-Time Rate" value={`${kpis.onTimeRate}%`} data-id="element-682" />
      </div>
    </div>;
}
function KPICard({
  icon,
  label,
  value,
  trend,
  trendValue,
  valueColor = 'text-slate-100'
}: any) {
  return <div className="flex flex-col" data-id="element-684">
      <div className="flex items-center gap-1.5 text-xs text-slate-400 mb-1" data-id="element-685">
        {icon}
        <span data-id="element-686">{label}</span>
      </div>
      <div className="flex items-baseline gap-2" data-id="element-687">
        <span className={`text-lg font-semibold font-mono ${valueColor}`} data-id="element-688">
          {value}
        </span>
        {trend && <span className={`flex items-center text-[10px] font-medium ${trend === 'up' ? 'text-brand-green' : 'text-brand-red'}`} data-id="element-689">
            {trend === 'up' ? <TrendingUp className="w-3 h-3 mr-0.5" data-id="element-690" /> : <TrendingDown className="w-3 h-3 mr-0.5" data-id="element-691" />}
            {trendValue}
          </span>}
      </div>
    </div>;
}